import Vue from 'vue'
import Vuex from 'vuex'
import token from './token'
import app from './app'
import { getQueryString } from '@/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    /**
     * 活动配置数据
     * @param download_url 下载地址
     */
    config: {},
    /**
     * 本地化数据
     */
    local: {},
    /**
     * 用户基本信息
     */
    user: null
  },
  getters: {
    // 活动功能配置
    abilities: state => state.config.ability_list || {},
    // 本地化数据
    local: state => state.local,
    // 下载地址
    donwloadUrl: state => state.config.download_url,
    // 用户数据
    user: state => state.user,
    // 是否绑定角色
    isBindRole: state => state.user && state.user.role_id,
    // 判断是否渠道页
    isChannel: () => {
      return getQueryString('referrer') === 'channel'
    },
    // 是否debug
    isDebug: state => {
      return state.local && state.local.base && state.local.base.debug === '1'
    },
    // 暂无获奖记录提示文本
    noRecordsTip: state => {
      return state.local && state.local.base && state.local.base.no_records
    },
    // 签到规则
    signinRule: state => {
      return state.local && state.local.base && state.local.base.signin_rule
    },
    // 可获取到抽奖券的签到日
    signinGetLotteryTicketDay: state => {
      return (
        state.local && state.local.base && Number(state.local.base.signin_get_lottery_ticket_day)
      )
    },
    // 签到获取到抽奖券时的提示
    signinGetLotteryTicketTip: state => {
      return state.local && state.local.base && state.local.base.signin_get_lottery_ticket_tip
    },
    // 组队活动规则
    teamRule: state => {
      return state.local && state.local.team && state.local.team.rules
    },
    // 创建队伍规则
    createTeamRule: state => {
      return state.local && state.local.team && state.local.team.create_rule
    },
    // 创建队伍确认提示
    createTeamConfirm: state => {
      return state.local && state.local.team && state.local.team.create_confirm
    },
    // 创建队伍奖励
    createTeamReward: state => {
      if (state.local && state.local.team) {
        return [
          {
            name: state.local.team.create_prize_1_name,
            icon: state.local.team.create_prize_1_icon
          },
          {
            name: state.local.team.create_prize_2_name,
            icon: state.local.team.create_prize_2_icon
          }
        ]
      }
      return []
    },
    // 邀请码分享文案
    inviteShareText: state => {
      return state.local && state.local.team && state.local.team.invite_prefix
    },
    // 回归特别礼
    specialGift: state => {
      if (state.local && state.local.team) {
        return {
          id: state.local.team.sg_prize_id,
          title: state.local.team.sg_title,
          rule: state.local.team.sg_rule,
          prizeName: state.local.team.sg_prize_name,
          prizeIcon: state.local.team.sg_prize_icon,
          lotteryTip: state.local.team.sg_lottery_tip
        }
      }
      return {}
    }
  },
  mutations: {
    // 设置活动配置数据
    SET_CONFIG(state, data) {
      state.config = data
    },
    // 设置本地化数据
    SET_LOCAL(state, data) {
      state.local = data
    },
    // 设置用户基本信息
    SET_USER(state, data) {
      state.user = data
    }
  },
  actions: {
    // 设置活动配置数据
    setConfig(context, data) {
      context.commit('SET_CONFIG', data)
    },
    // 设置本地化数据
    setLocal(context, data) {
      context.commit('SET_LOCAL', data)
    },
    // 设置用户基本信息
    setUser(context, data) {
      context.commit('SET_USER', data)
    }
  },
  modules: { token, app }
})
